<div class="hold-location-dialog p-4">
  <app-modal-header
    title="{{'getThisItemDialogTitle' | translate}}"
    titleId="hold-location-dialog-title"
    closeId="close-hold-location-dialog-btn"
    (close)="onClose()">
  </app-modal-header>
  <div class="modal-body mt-n4 mb-2">
    <h3 class="hold-resource-title notranslate" *ngIf="hold.resource?.title" tabindex="-1"
        data-automation-id="hold-location-resource-title">
      {{ hold.resource.title }}
    </h3>
    <form id="hold-location-form" [formGroup]="holdLocationForm" class="hold-location-form" (ngSubmit)="onSubmit()">
      <app-pickup-location-select
        formControlName="pickupLocation"
        [pickupLocations]="pickupLocations"
        [selectedLocationCode]="selectedLocationCode"
        (codeChanging)="onChangePickupLocation($event)"
        [dataAutomationId]="'hold-pickup-location-select'">
      </app-pickup-location-select>

      <ng-container *ngIf="showPickupAreaFeature">
        <div *ngIf="pickupAreasLoading" class="d-flex justify-content-center my-10" aria-live="polite" role="status">
          <span class="spinner-border text-primary" data-automation-id="areas-spinner">
            <span class="sr-only" translate>Loading...</span>
          </span>
        </div>
        <ng-container *ngIf="!pickupAreasLoading && pickupAreas.length">
          <app-pickup-area-select
            formControlName="pickupArea"
            [availablePickupArea]="pickupAreas"
            [selectedPickupAreaCode]="holdLocationForm.get('pickupArea').value"
            [attr.aria-describedby]="'pickup-area-error'"
            [dataAutomationId]="'hold-pickup-area-select'">
          </app-pickup-area-select>
          <div aria-atomic="true" aria-live="assertive" role="alert">
            <p *ngIf="hasPickupAreaError"
               id="pickup-area-error"
               class="error-message pickup-area-error-message">
              {{ 'pickupErrorMessage' | translate }}
            </p>
          </div>
        </ng-container>
      </ng-container>

    </form>
  </div>
  <div class="modal-footer justify-content-start">
    <button
      class="ins-buttons button-primary flint"
      type="submit"
      form="hold-location-form"
      [disabled]="hasPickupAreaError"
      data-automation-id="confirm-hold-location-btn"
      translate>
      confirmLocation
    </button>
    <button
      type="button"
      class="ins-buttons button-secondary flint ml-3"
      (click)="onClose()"
      data-automation-id="cancel-hold-location-btn"
      translate>
      cancelButton
    </button>
  </div>
</div>
